import { render, staticRenderFns } from "./priSettingsBenchmarkThirdParties.vue?vue&type=template&id=8e2c2840"
import script from "./priSettingsBenchmarkThirdParties.vue?vue&type=script&lang=js"
export * from "./priSettingsBenchmarkThirdParties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports